module.exports = __webpack_public_path__ + "app/assets/img/m_header_logo_none.325ef0bf.png";